import React from 'react';
import { Component } from 'react';

export default class ServicoBagagemVolumeEncomendaTurissul extends Component {

    render() {
        return (
            <>
                <div className="menu-accordion-heading">
                    <a className="menu-accordion-toggle" href="#item-compra-8">
                        Bagagens - Volumes - Encomendas
                        <i className="fa fa-caret-down p-float-right"></i>
                    </a>
                </div>
                <div id="item-compra-8" className="menu-accordion-body"
                    style={{ overFlow: 'hidden', display: 'none' }}>
                    <div className="menu-accordion-inner">
                        <h3 className="menu-accordion-inner-trigger js-accordion-inner-trigger">
                            Quantas bagagens posso levar?
                            <i className="fa fa-caret-down p-float-right"></i>
                        </h3>
                        <div className="menu-accordion-inner-collapse">                            
                            <p>De acordo com as regras aplicáveis ao transporte rodoviário, o passageiro tem direito a:</p>
                            <p style={{'padding-left': '5px'}}>• <b>1 mala de até 30 kg no bagageiro</b>, como bagagem despachada;</p>
                            <p style={{'padding-left': '5px'}}>• <b>1 bagagem de mão de até 5 kg.</b></p>
                            <p>Os limites podem variar conforme o tipo de serviço ou condições específicas da viagem.</p>
                        </div>
                        <h3 className="menu-accordion-inner-trigger js-accordion-inner-trigger">
                            Posso levar bagagem extra?
                            <i className="fa fa-caret-down p-float-right"></i>
                        </h3>
                        <div className="menu-accordion-inner-collapse">
                            <p>Sim, desde que haja disponibilidade.</p>
                            <p>Nesses casos:</p>                            
                            <p style={{'padding-left': '5px'}}>• Poderá haver <b>cobrança adicional</b>;</p>
                            <p style={{'padding-left': '5px'}}>• O transporte dependerá da <b>disponibilidade de espaço no ônibus</b>.</p>                            
                        </div>
                        <h3 className="menu-accordion-inner-trigger js-accordion-inner-trigger">
                            E se minha bagagem for extraviada ou danificada?
                            <i className="fa fa-caret-down p-float-right"></i>
                        </h3>
                        <div className="menu-accordion-inner-collapse">
                            <p>Caso perceba o extravio ou algum dano em sua bagagem, comunique imediatamente o motorista ou responsável pela viagem ao receber as bagagens no destino.</p>
                            <p>Tenha em mãos:</p>
                            <p style={{'padding-left': '5px'}}>• Bilhete ou passagem da viagem;</p>
                            <p style={{'padding-left': '5px'}}>• Documento de identificação;</p>
                            <p style={{'padding-left': '5px'}}>• Comprovante ou identificação da bagagem.</p>
                            <p>A empresa é responsável pelas bagagens despachadas e deverá seguir os procedimentos aplicáveis em caso de extravio ou danos.</p>
                        </div>
                       
                    </div>
                </div>
            </>
        )
    }
}